// @flow
'use strict';

import { connect } from 'react-redux';

import ModalDetalhes from './modal_detalhes';

export default connect<*, *, *, *, *, *>()(ModalDetalhes);
